import { render, staticRenderFns } from "./WorkStatus.vue?vue&type=template&id=c23f60b2&scoped=true&"
import script from "./WorkStatus.vue?vue&type=script&lang=js&"
export * from "./WorkStatus.vue?vue&type=script&lang=js&"
import style0 from "./WorkStatus.vue?vue&type=style&index=0&id=c23f60b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23f60b2",
  null
  
)

export default component.exports